import { render, staticRenderFns } from "./DutiesList.vue?vue&type=template&id=b20a88c8&scoped=true&"
import script from "./DutiesList.vue?vue&type=script&lang=js&"
export * from "./DutiesList.vue?vue&type=script&lang=js&"
import style0 from "./DutiesList.vue?vue&type=style&index=0&id=b20a88c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20a88c8",
  null
  
)

export default component.exports